export default __webpack_public_path__ + "static/media/footer-bg-dark-smm.12239d35.svg";